import {  axiosAjaxCall } from './common.service'

export const autoReminderCronLogsService = {
    getAutoReminderCronLogs,
}

function getAutoReminderCronLogs(data) {
    return axiosAjaxCall("get_auto_reminder_corn_logs", data);
}